import { EntityBase } from './EntityBase';
import { Material } from './Material';
import { AssessmentCategory } from './AssessmentCategory';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class MaterialAssessmentCategory extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   materialId: number;
   assessmentCategoryId: number;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   assessmentCategory: AssessmentCategory;
   material: Material;
}

